import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import { compareNumbers } from 'apollo-react/components/Table';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import SortPrintOrderTable from './SortPrintOrderTable';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { bulkUpdateFormData } from '../../actions/runtime.actions';
import { FormContext } from '../../context';

const useStyles = makeStyles({
  modal: {
    width: '100%',
    maxWidth: 1200,
  },
});

const SortPrintOrderModal = ({ open, onClose, originalRows, entityName }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const formKey = useContext(FormContext);

  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (open) {
      const sortedRows = [...originalRows]
        .sort(compareNumbers('DBP_PRINT_ORDER', 'asc'))
        .map((row, i) => ({ ...row, _printOrder: i }));

      setRows(sortedRows);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleSave = () => {
    const changesArray = rows.map((row) => ({
      entityName,
      fieldName: 'DBP_PRINT_ORDER',
      index: [row.index],
      value: row._printOrder,
    }));

    dispatch(bulkUpdateFormData(changesArray, formKey));
    onClose(true);
  };

  return (
    <Modal
      className={classes.modal}
      open={open}
      onClose={() => onClose()}
      title={translateString('Sort Print Order')}
      buttonProps={[
        { label: translateString('Cancel') },
        {
          label: translateString('Save'),
          onClick: handleSave,
        },
      ]}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <SortPrintOrderTable rows={rows} setRows={setRows} />
    </Modal>
  );
};

export default SortPrintOrderModal;
